import React, { Fragment, useEffect, useState } from "react";
import TitleBox from "../../components/common/TitleBox";
import SlotCenter from "../../components/Slot/SlotCenter";
import Headbar from "../../components/Layout/Headbar";
import {
  getGameLaunch,
  getlistImgPath,
  getLobbylist,
  getTitle,
  isEmpty,
  toastr,
} from "../../common/cores";
import { SetPageLoading } from "../../common/actions/pageAction";
import connect from "react-redux/lib/connect/connect";
import Footbar, { MobileFootbar } from "../../components/Layout/Footbar";
import { isMobile } from "../../utils/utils";

const Casino = (props) => {
  const { isAuthenticated, user, casinoStatus } = props;

  const [casinoLists, setCasinoLists] = useState([]);

  const gameType = "casino";

  const getLoginLists = () => {
    props.SetPageLoading(true);
    const params = {
      type: gameType,
      token: user.loginId,
      username: user.loginId,
      status: casinoStatus,
    };
    getLobbylist(params).then((data) => {
      setCasinoLists(data.lobbyList);
      props.SetPageLoading(false);
    });
  };

  const onClickCasino = (list, event) => {
    event.preventDefault();
    if (!isAuthenticated) {
      toastr.warning(
        isEmpty(window.lang["로그인하시고 이용해주세요."])
          ? "로그인하시고 이용해주세요."
          : window.lang["로그인하시고 이용해주세요."]
      );
      return;
    }
    props.SetPageLoading(true);
    // console.log(localStorage);
    const params = {
      ...list,
      type: "casino",
      username: user.loginId,
      ipADD: localStorage.getItem("client-ip"),
    };
    getGameLaunch(params);
  };

  useEffect(() => {
    if (!isAuthenticated) {
      toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
      window.location.href = "/";
    }
    getLoginLists("casino");
  }, [isAuthenticated]);

  const onClickMemMenu = (e) => {
    if (!isAuthenticated) {
      e.preventDefault();
      toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    }
  };

  return (
    <Fragment>
      <div id="layoutBody" style={{ paddingTop: "0px" }}>
        <div className="wrapper  lang_ko" id="bodyTemplate">
          <div id="contentTheme"></div>
          <Headbar />
          <div className="container main_section">
            <div
              className="main_visual"
              style={{ display: isMobile() ? "none" : "block" }}
            >
              <div className="notice_area">
                <div className="inner">
                  <p className="tit">
                    {" "}
                    <img src="/r/front/img/main/txt_notice.jpg" alt="notice" />
                    <span className="" langkey="new_theme.common.notification">
                      {isEmpty(window.lang["공지"])
                        ? "공지"
                        : window.lang["공지"]}
                    </span>{" "}
                  </p>
                  <div className="marquee">
                    <div>
                      <p
                        className="txt"
                        id="lineMsg"
                        style={{ color: "rgb(255, 255, 255)" }}
                      >
                        {isEmpty(
                          window.lang[
                            "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                          ]
                        )
                          ? "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                          : window.lang[
                              "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                            ]}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container contents">
              <div id="gameList">
                <div className="game_list1" id="category2289">
                  <div className="sport inner">
                    <div className="titlebox">
                      <h4>
                        {isEmpty(window.lang["라이브카지노"])
                          ? "라이브카지노"
                          : window.lang["라이브카지노"]}{" "}
                      </h4>
                    </div>
                    <div
                      className="game_list_wrap"
                      id="game_list_wrap"
                      data-cat="2289"
                    >
                      <ul className="row">
                        {casinoLists.map((list, index) => {
                          return (
                            <li
                              className="col-6 col-md-3"
                              key={index}
                              data-move-url="/game/casino/detail/0?gamecode=12&amp;game_child_seq=3602&amp;event=N"
                              data-game-title="코리안 딜러 스피드 바카라"
                              data-game-title-en="Korean Speed Baccarat"
                              data-game-code="12"
                              data-game-meta-code="npn3y3hkld2mcdjt"
                              data-game-description="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                              data-game-video-url="c309b3d6f89ecc3395a96a02ca12a60e"
                              data-event_game_yn="N"
                              data-game-child-seq="3602"
                              onClick={(e) => {
                                onClickCasino(list, e);
                              }}
                            >
                              <span className="G005001"></span>{" "}
                              <img
                                className="videoPosterImages"
                                video-seq="0"
                                data-original="/upload/2021/0823/L6tP_zGpX_DGVE_qwOf.png?306x306c"
                                style={{
                                  width: "100%",
                                  height: "150px",
                                  objectFit: "cover",
                                }}
                                src={getlistImgPath(list)}
                              />
                              <div className="gameInfo">
                                <p className="gameTitle">
                                  {" "}
                                  {getTitle(list, props.language)}{" "}
                                </p>{" "}
                                <span
                                  className="gameDetailInfo"
                                  data-game-name="코리안 딜러 스피드 바카라"
                                  data-game-detail="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                                  langkey="col.reminders"
                                >
                                  유의사항
                                </span>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isMobile() ? <MobileFootbar /> : <Footbar />}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
  user: state.user.data,
  language: state.more.language,
});

export default connect(mapStateToProps, { SetPageLoading })(Casino);



// WEBPACK FOOTER //
// ./src/containers/Slot/Casino.js